export default __webpack_public_path__ + "static/unstuffy-40eea7ea25d897559028d511d4be61cf.png";